module.exports = __webpack_public_path__ + "img/Pista_0321_2.ed8c3070.png";